import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan. Coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg.replace("Value error, ", "") : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const rupiah = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");
export const pad = (n) => String(n).padStart(2, "0");
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" }) : "-");

export async function downloadAgenda(tahun, bulan) {
  const res = await api.get("/export/agenda", { params: { tahun, ...(bulan && { bulan }) }, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `agenda_surat_${tahun}${bulan ? "_" + pad(bulan) : ""}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadExcel(rt) {
  const res = await api.get("/export/warga", { params: rt ? { rt } : {}, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `data_penduduk_inauga_${rt ? "rt" + pad(rt) : "semua"}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
